<template>
    <div class="wa-status">
        <SOSlotBase :bg-grey="true" :loading="!formReady">
            <template v-slot:title-bar>
                <SOTitleBar :type="'back'" :page-title="'Status WA'" @back="back" />
            </template>
            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>
            <template v-slot:content v-if="formReady">
                <FilterStatusWA
                    :open-modal="gotoPilihPerangkat"
                    :number="getDeviceNumber"
                    :device-name="getDeviceName"
                />

                <div class="p-y-16 p-x-20">
                    <div class="p-d-16" v-if="getAktif.count > 0">
                        <div class="f-regular f-16 f-c-midgrey m-d-16">
                            Sedang aktif
                        </div>
                        <CardStatusWA :data-list="getAktif.array" />
                        <div
                            class="bg-white p-y-12 f-c-blue d-flex-between-center"
                            style="justify-content: center;"
                            @click="goViewAllAktif"
                            v-if="getHiddenAktif > 0"
                        >
                            <IconBased width="15" height="15">
                                <template v-slot:icons>
                                    <ArrowRight />
                                </template>
                            </IconBased>
                            <label class="m-l-8 m-d-0"> Lihat semua {{ getHiddenAktif }} postingan aktif </label>
                        </div>
                    </div>

                    <div class="p-t-16" v-if="getRiwayat.length > 0">
                        <div class="f-regular f-16 f-c-midgrey m-d-16">
                            Riwayat postingan
                        </div>
                        <CardStatusWA :data-list="getRiwayat" />
                        <div
                            class="bg-white p-y-12 f-c-blue d-flex-between-center"
                            style="justify-content: center;"
                            @click="goViewAllRiwayat"
                        >
                            <IconBased width="15" height="15">
                                <template v-slot:icons>
                                    <ArrowRight />
                                </template>
                            </IconBased>
                            <label class="m-d-0 m-l-8">Lihat semua riwayat</label>
                        </div>
                    </div>
                </div>

                <SOFABRegular @add="gotoAddForm" />
            </template>

            <template v-slot:empty-state>
                <SOEmptyState
                    v-if="false"
                    :message="'Tidak ada status yang aktif'"
                    :sub-message="'Klik tombol + untuk membuat status WA '"
                />
            </template>
        </SOSlotBase>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOFABRegular from "@/so-components/global/ui/SOFABRegular";
import FilterStatusWA from "@/modules/wa-status/components/FilterStatusWA";
import CardStatusWA from "@/modules/wa-status/components/CardStatusWA";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";

import IconBased from "@/modules/wa-autosender/components/iconPack/IconBased.vue";
import ArrowRight from "../components/iconPack/RightArrow1515.vue";

import { moduleName } from "../store/state";

export default {
    name: "WAStatusList",
    components: {
        CardStatusWA,
        SOSlotBase,
        SOTitleBar,
        SOLoadingPage,
        SOFABRegular,
        FilterStatusWA,
        SOEmptyState,
        IconBased,
        ArrowRight,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (from.name === "wa_autosender.detail_perangkat") {
                vm.setBackTo(from.name);
            }
            if (from.name === "wa_status.create_status" || from.name === "wa_status.detail_status") {
                vm.setDoLoadPage(false);
            }
            if (from.name === "wa_status.status_aktif") {
                if (from.params.aktif_id) {
                    vm.getDetailTinyDevice({ deviceId: from.params.aktif_id });
                }
            }
        });
    },
    data() {
        return {
            backTo: "dashboard",
            formReady: false,
            doLoadPage: true,
        };
    },
    watch: {
        response: function(newRes, oldRes) {
            if (newRes.success) {
                this.setFormReady(true);

                if (!this.doLoadPage && newRes.data === "wa_status") {
                    this.$toast.success(newRes.msg);
                }
            } else {
                if (!this.doLoadPage && newRes.data === "wa_status") {
                    this.$toast.error(newRes.err);
                    this.$router.go(-1);
                }
            }
        },
        dataDeviceTiny: function(newD, oldD) {
            if (newD.iddevice !== oldD.iddevice) {
                this.loadDataList(newD.iddevice);
            }
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            dataDeviceTiny: "dataDeviceTiny",
            storyIndex: "storyIndex",
            response: "response",
        }),
        getAktif() {
            return this.storyIndex.aktif ? this.storyIndex.aktif : [];
        },
        getHiddenAktif() {
            let { count, array } = this.getAktif;
            return count - array.length;
        },
        getRiwayat() {
            return this.storyIndex.riwayat ? this.storyIndex.riwayat : [];
        },
        getDeviceNumber() {
            return this.dataDeviceTiny.number ? `+${this.dataDeviceTiny.country_code}${this.dataDeviceTiny.number}` : "";
        },
        getDeviceName() {
            return this.dataDeviceTiny.nama ? this.dataDeviceTiny.nama : "";
        },
        getDeviceId() {
            return this.$route.params.deviceId ? this.$route.params.deviceId : "";
        },
        isFoto() {
            return (mtype) => {
                return mtype === 2;
            };
        },
        isVideo() {
            return (mtype) => {
                return mtype === 3;
            };
        },
        isText() {
            return (mtype) => {
                return mtype === 1;
            };
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapActions({
            getListPerangkat: `${moduleName}/getListPerangkat`,
            setDeviceid: `${moduleName}/setDeviceid`,
            getWaStoryIndex: `${moduleName}/getWaStoryIndex`,
            resetDataDeviceTiny: `${moduleName}/resetDataDeviceTiny`,
            getDetailTinyDevice: `${moduleName}/getDetailTinyDevice`,
            setFileUpload: `${moduleName}/setFileUpload`,
            resetPage: `${moduleName}/resetPage`,
            resetList: `${moduleName}/resetList`,
        }),
        dataReset(target) {
            this.resetPage({ target });
            this.resetList({ target });
        },
        setDoLoadPage(val) {
            this.doLoadPage = val;
        },
        setFormReady(val) {
            this.formReady = val;
        },
        setBackTo(val) {
            this.backTo = val;
        },
        back() {
            this.$router.go(-1);
        },
        loadDataList(getDeviceId) {
            this.getWaStoryIndex({ iddevice: getDeviceId });
        },
        init() {
            let { getDeviceId, doLoadPage } = this;
            let payload = {
                loadDevice: false,
                deviceId: null,
            };

            if (getDeviceId) {
                this.setDeviceid(getDeviceId);
                payload.loadDevice = true;
                payload.deviceId = getDeviceId;
            }

            if (doLoadPage) {
                this.resetDataDeviceTiny();
                this.getListPerangkat(payload);
                this.loadDataList(getDeviceId);
            } else {
                this.setFormReady(true);
            }
        },
        gotoPilihPerangkat() {
            this.$router.push({ name: "wa_status.pilih_perangkat" });
        },
        gotoAddForm() {
            this.$router.push({ name: "wa_status.create_status" });
            this.setFileUpload("");
        },
        async goViewAllAktif() {
            await this.dataReset("storyAktif");
            let linkto = { name: "wa_status.status_aktif" };
            if (this.dataDeviceTiny.iddevice) {
                linkto.params = { aktif_id: this.dataDeviceTiny.iddevice };
            }
            await this.$router.push(linkto);
        },
        goViewAllRiwayat() {
            let linkto = { name: "wa_status.riwayat_status" };
            if (this.dataDeviceTiny.iddevice) {
                linkto.params = { iddevice: this.dataDeviceTiny.iddevice };
            }
            this.$router.push(linkto);
        },
    },
};
</script>

<style scoped>
.btn-shadow {
    box-shadow: 0 4px 12px rgba(0, 34, 119, 0.06);
}
</style>
